'use strict';

exports.__esModule = true;
exports.typeForVideoURL = typeForVideoURL;
exports.infoForVideoWithURL = infoForVideoWithURL;

var _youTube = require('./youTube');

var youTube = _interopRequireWildcard(_youTube);

var _vimeo = require('./vimeo');

var vimeo = _interopRequireWildcard(_vimeo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function typeForVideoURL(videoURL) {
	if (youTube.isValidVideoURL(videoURL)) {
		return youTube.sourceType;
	} else if (vimeo.isValidVideoURL(videoURL)) {
		return vimeo.sourceType;
	} else {
		return;
	}
}

function handlerForVideoURL(videoURL) {
	switch (typeForVideoURL(videoURL)) {
		case youTube.sourceType:
			return youTube;
		case vimeo.sourceType:
			return vimeo;
		default:
			return;
	}
}

function infoForVideoWithURL(videoURL) {
	var options = arguments.length <= 1 || arguments[1] === undefined ? {} : arguments[1];

	var handler = handlerForVideoURL(videoURL);
	if (handler) {
		return handler.infoForVideoWithURL(videoURL, options);
	} else {
		return Promise.reject({
			videoURL: videoURL,
			noHandler: true
		});
	}
}


//////////////////
// WEBPACK FOOTER
// ./~/silverscreen/lib/index.js
// module id = 693
// module chunks = 0